import { Controller } from "@hotwired/stimulus"
import throttle from "../../utils/throttle"
export default class extends Controller {

    static targets = ['submenu', 'container'];
    connect() {
        this.computeSubmenuPositions();
        document.fonts.ready.then(() => {
            this.computeSubmenuPositions();
        });

        this.lastScroll = 0;
        this.onScroll = this.handleScroll.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });

    }
    disconnect() {
        window.removeEventListener('scroll', this.onScroll);
    }

    handleScroll() {
        const current = window.scrollY;

        if(window.matchMedia('(max-width: 1199px').matches) {
            this.containerTarget.classList.remove('is-hidden');
            return
        }

        if (current <= 0) {
            this.containerTarget.classList.remove('is-hidden');
        } else if (current > this.lastScroll) {
            this.containerTarget.classList.add('is-hidden');
        } else {
            this.containerTarget.classList.remove('is-hidden');
        }
        this.lastScroll = current;
    }
    onSubmenuEnter(e) {
        if(window.matchMedia('(max-width: 1199px').matches) {
            return;
        }

        const div = e.currentTarget.closest('li').querySelector('.js-level2');
        if (!div) return;
        div.style.display = 'block';

        requestAnimationFrame(() => {
            const rootTop    = this.containerTarget.getBoundingClientRect().top;
            const divBottom  = div.getBoundingClientRect().bottom;
            this.containerTarget.style.setProperty('--menuHeight', `${divBottom - rootTop}px`);
        });
    }
    onSubmenuLeave(e) {
        if(window.matchMedia('(max-width: 1199px').matches) {
            return;
        }
        if (e.relatedTarget && e.currentTarget.contains(e.relatedTarget)) return;
        const div = e.currentTarget.querySelector('.js-level2');
        if (!div) return;

        div.style.display = '';
        this.containerTarget.style.removeProperty('--menuHeight');
    }
    computeSubmenuPositions() {
        let menuMobile = false;
        if(window.matchMedia('(max-width: 1199px').matches) {
            menuMobile = true;
        }
        const rootLeft = this.containerTarget.getBoundingClientRect().left;
        this.submenuTargets.forEach(submenu => {
            const submenuLeft = submenu.getBoundingClientRect().left;
            const posLeft = submenuLeft - rootLeft;
            const ul = submenu.querySelector('ul');
            if (ul) {
                if(!menuMobile) {
                    ul.style.setProperty('--posLeft', `${posLeft}px`);
                } else {
                    ul.style.removeProperty('--posLeft');
                }
            }
        });
    }

    openMenu() {
        this.computeSubmenuPositions();
        this.element.setAttribute('data-menuopen','true');
        document.body.setAttribute('data-menuopen', 'true')
    }
    closeMenu() {
        this.element.removeAttribute('data-menuopen');
        document.body.removeAttribute('data-menuopen')
        this.submenuTargets.forEach(submenu => submenu.removeAttribute('data-open'));
    }
    toggleSubmenu(e) {
        let parent = e.currentTarget.closest('li');
        if(parent.getAttribute('data-open')) {
            parent.removeAttribute('data-open')
        } else {
            this.submenuTargets.forEach(submenu => submenu.removeAttribute('data-open'));
            parent.setAttribute('data-open', 'true');
        }
    }
}
